import React from "react"
import { RichText as PrismicRichText, RichTextBlock } from "prismic-reactjs"
import styled from "styled-components"

import {
  Element,
  ElementProps,
  LinkSerializer,
  rawHtmlCss,
} from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"


interface OwnProps {
  color?: string
  render: Maybe<RichTextBlock>
}

export type RichTextProps = ElementProps & OwnProps

const RichText = styled(({ color = "navy", render, ...elementProps }) => {
  return (
    <Element color={color} {...elementProps}>
      <PrismicRichText
        render={render}
        serializeHyperlink={LinkSerializer}
      />
    </Element>
  )
})<RichTextProps>`
  ${rawHtmlCss}
`

export default RichText
